/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type VisibilityEnum = 'pu' | 'un' | 'pr' | 'cu' | 'ar' | 'dr' | '11184809';

export const VisibilityEnum = {
  PU: 'pu' as VisibilityEnum,
  UN: 'un' as VisibilityEnum,
  PR: 'pr' as VisibilityEnum,
  CU: 'cu' as VisibilityEnum,
  AR: 'ar' as VisibilityEnum,
  DR: 'dr' as VisibilityEnum,
  UNKNOWN_DEFAULT_OPEN_API: '11184809' as VisibilityEnum
};
